export default {
  bind(el, binding, vnode) {
    el.addEventListener('load', () => {
      vnode.context.$emit('load')
    })
  },
}



// WEBPACK FOOTER //
// ./src/directives/load.js